import { React, useState, useEffect } from 'react'
import logoImage from '../../assets/img/logo.png'
import { menu } from './menu'
import { Link , useLocation} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook , faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope , faPhone, faClock, faMapMarked, faBars, faArrowUp} from '@fortawesome/free-solid-svg-icons'

import styles from './Header.module.scss'

const Header = () => {
  const location = useLocation()
  const getColor=(curr)=>{
    if(location.pathname===curr){
      return "green"
    }
  }
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactsCollapsed, setContactsCollapsed] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [size, setSize] = useState({
    width: undefined,
    height: undefined,
  })

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if(size.width > 1200){
      setMenuOpen(false);
      setContactsCollapsed(false);
    }
  }, [size.width, menuOpen, contactsCollapsed])


  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <div className={styles.logo}>
          <Link to="/" aria-label="На головну сторінку">
            <img
              className={`${styles.logoImage} ${logoLoaded ? styles.logoLoaded : ''}`}
              src={logoImage}
              width="524"
              height="291"
              alt="Салон краси Нія"
              loading="eager"
              decoding="async"
              onLoad={() => setLogoLoaded(true)}
            />
          </Link>
        </div>
        <nav className={styles.menuWrapper}>
          <button 
            className={styles.toggleButton}
            aria-expanded={!menuOpen}
            aria-controls="main-menu"
            onClick={() => setMenuOpen(!menuOpen)}>
            <FontAwesomeIcon icon={faBars} />
            <span>МЕНЮ</span>
          </button>
          <ul
            id="main-menu"
            className={`${styles.menu} ${menuOpen ? styles.menuCollapsed : ''}`}
          >
            {menu.map((item)=>(
              <li key={item.link}>
                <span>
                  <Link to={{ pathname: item.link, hash: item.hash}} style={{color:getColor(item.link)}}>{item.title}</Link>
                </span>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className={styles.underMenuWrapper}>
        <div id="header-contacts" className={`${styles.collapsibleContent} ${contactsCollapsed ? styles.collapsed : ''}`}>
          <div className={styles.headerContacts}>
            <div className={styles.contactItem}>
              <FontAwesomeIcon icon={faPhone} />
              <p>
                <a href="tel:0687775858" >+38 (068) 777-58-58</a>
                <br/>
                <a href="tel:0663077052" >+38 (066) 307-70-52</a>
              </p>
            </div>
            <div className={styles.contactItem}>
              <FontAwesomeIcon icon={faEnvelope} />
              <a href="mailto:nia@gmail.com">nia@gmail.com</a>
            </div>
            <div className={styles.contactItem}>
              <FontAwesomeIcon icon={faMapMarked} />
              <p>
                <strong>САЛОН НІЯ</strong>
                <br/>
                Зіньків, вулиця Погрібняка, 5-A
              </p>
            </div>
            <div className={styles.contactItem}>
              <FontAwesomeIcon icon={faClock} />
              <p>
                Пн. - Сб.: 09:00 - 18:00
                <br/>
                Нед.: 09:00 - 15:00
              </p>
            </div>
          </div>
          <div className={styles.headerSocial}>
            <a className={styles.sotialIcon} href="https://www.facebook.com/niiabeautyz/photos/?ref=page_internal" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a className={styles.sotialIcon} href="https://www.instagram.com/niia_beautyz/" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a className={styles.sotialIcon} href="mailto:nia@gmail.com" aria-label="Написати електронного листа">
              <FontAwesomeIcon icon={faEnvelope} />
            </a>
          </div>
        </div>
        <button 
          className={`${styles.toggleButtonBottom} ${contactsCollapsed ? styles.toggleCollapsed : ''}`}
          aria-expanded={!contactsCollapsed}
          aria-label="Показати або приховати контакти"
          aria-controls="header-contacts"
          onClick={() => setContactsCollapsed(!contactsCollapsed)}>
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      </div>
    </header>
  )
}

export default Header
